window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ App ================*/
('use strict');
var _typeof =
    'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
      ? function (e) {
          return typeof e;
        }
      : function (e) {
          return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
        },
  _createClass = (function () {
    function i(e, t) {
      for (var o = 0; o < t.length; o++) {
        var i = t[o];
        (i.enumerable = i.enumerable || !1), (i.configurable = !0), 'value' in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }
    return function (e, t, o) {
      return t && i(e.prototype, t), o && i(e, o), e;
    };
  })();
function _possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
}
function _inherits(e, t) {
  if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
  (e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0,
    },
  })),
    t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
}
(slate.a11y = {
  pageLinkFocus: function (e) {
    var t = 'js-focus-hidden';
    e.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(t)
      .one('blur', function () {
        e.first().removeClass(t).removeAttr('tabindex');
      });
  },
  focusHash: function () {
    var e = window.location.hash;
    e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
  },
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (e) {
        this.pageLinkFocus($(e.currentTarget.hash));
      }.bind(this)
    );
  },
  trapFocus: function (t) {
    var e = t.namespace ? 'focusin.' + t.namespace : 'focusin';
    t.$elementToFocus || (t.$elementToFocus = t.$container),
      t.$container.attr('tabindex', '-1'),
      t.$elementToFocus.focus(),
      $(document).on(e, function (e) {
        t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus();
      });
  },
  removeTrapFocus: function (e) {
    var t = e.namespace ? 'focusin.' + e.namespace : 'focusin';
    e.$container && e.$container.length && e.$container.removeAttr('tabindex'), $(document).off(t);
  },
}),
  (slate.cart = {
    cookiesEnabled: function () {
      var e = navigator.cookieEnabled;
      return e || ((document.cookie = 'testcookie'), (e = -1 !== document.cookie.indexOf('testcookie'))), e;
    },
  }),
  (slate.Currency = {
    formatMoney: function (e, t) {
      'string' == typeof e && (e = e.replace('.', ''));
      var o = '',
        i = /\{\{\s*(\w+)\s*\}\}/,
        n = t || '${{amount}}';
      function a(e, t, o, i) {
        if (((t = slate.utils.defaultTo(t, 2)), (o = slate.utils.defaultTo(o, ',')), (i = slate.utils.defaultTo(i, '.')), isNaN(e) || null == e)) return 0;
        var n = (e = (e / 100).toFixed(t)).split('.');
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + o) + (n[1] ? i + n[1] : '');
      }
      switch (n.match(i)[1]) {
        case 'amount':
          o = a(e, 2);
          break;
        case 'amount_no_decimals':
          o = a(e, 0);
          break;
        case 'amount_with_space_separator':
          o = a(e, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          o = a(e, 0, ',', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          o = a(e, 0, ' ');
      }
      return n.replace(i, o);
    },
  }),
  (slate.Image = {
    preload: function (e, t) {
      'string' == typeof e && (e = [e]);
      for (var o = 0; o < e.length; o++) {
        var i = e[o];
        this.loadImage(this.getSizedImageUrl(i, t));
      }
    },
    loadImage: function (e) {
      new Image().src = e;
    },
    imageSize: function (e) {
      var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      return t ? t[1] : null;
    },
    getSizedImageUrl: function (e, t) {
      if (null === t) return e;
      if ('master' === t) return this.removeProtocol(e);
      var o = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (o) {
        var i = e.split(o[0]),
          n = o[0];
        return this.removeProtocol(i[0] + '_' + t + n);
      }
      return null;
    },
    removeProtocol: function (e) {
      return e.replace(/http(s)?:/, '');
    },
  }),
  (slate.rte = {
    wrapTable: function (e) {
      var t = void 0 === e.tableWrapperClass ? '' : e.tableWrapperClass;
      e.$tables.wrap('<div class="' + t + '"></div>');
    },
    wrapIframe: function (e) {
      var t = void 0 === e.iframeWrapperClass ? '' : e.iframeWrapperClass;
      e.$iframes.each(function () {
        $(this).wrap('<div class="' + t + '"></div>'), (this.src = this.src);
      });
    },
  }),
  (slate.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  }),
  (slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function (e, t) {
      var o = $(e),
        i = o.attr('data-section-id'),
        n = o.attr('data-section-type');
      if (void 0 !== (t = t || this.constructors[n])) {
        var a = $.extend(new t(e), {
          id: i,
          type: n,
          container: e,
        });
        this.instances.push(a);
      }
    },
    _onSectionLoad: function (e) {
      var t = $('[data-section-id]', e.target)[0];
      t && this._createInstance(t);
    },
    _onSectionUnload: function (e) {
      var t = slate.utils.findInstance(this.instances, 'id', e.detail.sectionId);
      t && ('function' == typeof t.onUnload && t.onUnload(e), (this.instances = slate.utils.removeInstance(this.instances, 'id', e.detail.sectionId)));
    },
    _onSelect: function (e) {
      var t = slate.utils.findInstance(this.instances, 'id', e.detail.sectionId);
      t && 'function' == typeof t.onSelect && t.onSelect(e);
    },
    _onDeselect: function (e) {
      var t = slate.utils.findInstance(this.instances, 'id', e.detail.sectionId);
      t && 'function' == typeof t.onDeselect && t.onDeselect(e);
    },
    _onReorder: function (e) {
      var t = slate.utils.findInstance(this.instances, 'id', e.detail.sectionId);
      t && 'function' == typeof t.onReorder && t.onReorder(e);
    },
    _onBlockSelect: function (e) {
      var t = slate.utils.findInstance(this.instances, 'id', e.detail.sectionId);
      t && 'function' == typeof t.onBlockSelect && t.onBlockSelect(e);
    },
    _onBlockDeselect: function (e) {
      var t = slate.utils.findInstance(this.instances, 'id', e.detail.sectionId);
      t && 'function' == typeof t.onBlockDeselect && t.onBlockDeselect(e);
    },
    register: function (e, o) {
      (this.constructors[e] = o),
        $('[data-section-type=' + e + ']').each(
          function (e, t) {
            this._createInstance(t, o);
          }.bind(this)
        );
    },
  })),
  (slate.utils = {
    findInstance: function (e, t, o) {
      for (var i = 0; i < e.length; i++) if (e[i][t] === o) return e[i];
    },
    removeInstance: function (e, t, o) {
      for (var i = e.length; i--; )
        if (e[i][t] === o) {
          e.splice(i, 1);
          break;
        }
      return e;
    },
    compact: function (e) {
      for (var t = -1, o = null == e ? 0 : e.length, i = 0, n = []; ++t < o; ) {
        var a = e[t];
        a && (n[i++] = a);
      }
      return n;
    },
    defaultTo: function (e, t) {
      return null == e || e != e ? t : e;
    },
  });
var AbstractComponent = function e(t) {
    _classCallCheck(this, e), (this.component = t);
  },
  AbstractSection = function e(t) {
    _classCallCheck(this, e), (this.section = t);
  },
  AbstractSnippet = function e(t) {
    _classCallCheck(this, e), (this.snippet = t);
  },
  QuickView = (function () {
    function e() {
      _classCallCheck(this, e), (this.loading = !1);
      (this.modal = $(
        '            <div style="display: none;" class="modal-quickview reveal large" data-reveal>                <a class="close-button" data-close aria-label="Close Quick View">                    <svg aria-hidden="true" viewBox="0 0 100 100" class="icon icon-cross">                        <path fill="#010101" d="M61.88 50l35.65-35.65A8.401 8.401 0 0 0 85.65 2.47L50                         38.12 14.35 2.46A8.401 8.401 0 0 0 2.47 14.34L38.12 50 2.46 85.65a8.401 8.401                        0 0 0 11.88 11.88L50 61.88l35.65 35.65a8.401 8.401 0 0 0 11.88-11.88L61.88 50z"/>                    </svg>                </a>                <div class="modal-content"></div>            </div>'
      )),
        (this.modalContent = this.modal.find('.modal-content')),
        this.modal.foundation(),
        this.initQuickViewButtons();
    }
    return (
      _createClass(e, [
        {
          key: 'initQuickViewButtons',
          value: function () {
            var i = this;
            $('[data-product-quickview]')
              .unbind('click.quickview')
              .bind('click.quickview', function (e) {
                e.preventDefault();
                var t = $(this);
                if (i.loading) return !1;
                var o = $(this).data('product-url');
                o &&
                  ((i.loading = !0),
                  t.addClass('js-loading'),
                  $.ajax({
                    type: 'get',
                    url: o,
                    dataType: 'html',
                    data: {
                      view: 'quickview',
                    },
                    success: function (e) {
                      i.modalContent.html(e), i.modal.foundation('open'), ShopifyApp.initAutoloadClasses(), (i.loading = !1);
                    },
                    complete: function () {
                      setTimeout(function () {
                        $('body')[0].dispatchEvent(new Event('shopify-wishlist.refresh'));
                      }, 100),
                        setTimeout(function () {
                          (i.loading = !1), t.removeClass('js-loading');
                        }, 200);
                    },
                  }));
              });
          },
        },
      ]),
      e
    );
  })(),
  ShopifyCart = (function (e) {
    function t() {
      _classCallCheck(this, t);
      var e = _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
      return (e.cart = {}), (e.queue = []), (e.queueActive = !1), e.setCart(), e;
    }
    return (
      _inherits(t, EventEmitter),
      _createClass(t, [
        {
          key: 'getCart',
          value: function () {
            return this.cart;
          },
        },
        {
          key: 'setCart',
          value: function () {
            null !== localStorage.getItem('shopify_cart') && this.updateCart(JSON.parse(localStorage.getItem('shopify_cart'))), this.getCartAction();
          },
        },
        {
          key: 'updateCart',
          value: function (e) {
            (this.cart = e), this.emit('cart.update'), localStorage.setItem('shopify_cart', JSON.stringify(this.cart));
          },
        },
        {
          key: 'refreshCart',
          value: function () {
            this.getCartAction();
          },
        },
        {
          key: 'getItemCount',
          value: function () {
            var e = 0;
            return this.cart.hasOwnProperty('item_count') && this.cart.item_count && (e = parseInt(this.cart.item_count)), e;
          },
        },
        {
          key: 'addActionToQueue',
          value: function (e) {
            this.queue.push(e), this.queueActive || this.moveAlongQueue();
          },
        },
        {
          key: 'moveAlongQueue',
          value: function () {
            var t = this;
            if (t.queue.length) {
              t.queueActive = !0;
              var o = t.queue.shift();
              switch (o.action) {
                case 'addItem':
                  t.addItemAction(o.variantID, o.quantity, o.properties).then(
                    function () {
                      o.defer.resolve(), t.moveAlongQueue();
                    },
                    function (e) {
                      o.defer.reject(e), t.moveAlongQueue();
                    }
                  );
                  break;
                case 'removeItem':
                  t.removeItemAction(o.variantID).then(
                    function () {
                      o.defer.resolve(), t.moveAlongQueue();
                    },
                    function (e) {
                      o.defer.reject(e), t.moveAlongQueue();
                    }
                  );
                  break;
                case 'updateItem':
                  t.updateItemAction(o.variantID, o.quantity).then(
                    function () {
                      o.defer.resolve(), t.moveAlongQueue();
                    },
                    function (e) {
                      o.defer.reject(e), t.moveAlongQueue();
                    }
                  );
              }
            } else t.queueActive = !1;
          },
        },
        {
          key: 'getErrorResponse',
          value: function (e) {
            var t = {
              description: '',
              message: '',
            };
            return e.hasOwnProperty('responseJSON') && (e.responseJSON.hasOwnProperty('message') && (t.message = e.responseJSON.message), e.responseJSON.hasOwnProperty('description') && (t.description = e.responseJSON.description)), t;
          },
        },
        {
          key: 'getCartAction',
          value: function () {
            var t = this,
              o = $.Deferred();
            return (
              $.ajax({
                type: 'get',
                url: '/cart.js',
                dataType: 'json',
                success: function (e) {
                  t.updateCart(e), o.resolve();
                },
                error: function (e) {
                  console.log('Error: failed to get cart'), console.log(e), o.reject(t.getErrorResponse(e));
                },
              }),
              o
            );
          },
        },
        {
          key: 'addItem',
          value: function (e, t, o) {
            var i = $.Deferred();
            return (
              this.addActionToQueue({
                action: 'addItem',
                variantID: e,
                quantity: t,
                properties: o,
                defer: i,
              }),
              i
            );
          },
        },
        {
          key: 'addItemAction',
          value: function (e, t, o) {
            var i = this,
              n = $.Deferred();
            return (
              $.ajax({
                type: 'post',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                  quantity: t,
                  id: e,
                  properties: o,
                },
                success: function (e) {
                  i.getCartAction().then(
                    function () {
                      n.resolve(), i.emit('cart.add');
                    },
                    function () {
                      n.reject();
                    }
                  );
                },
                error: function (e) {
                  console.log('error'), console.log(e), n.reject(i.getErrorResponse(e));
                },
              }),
              n
            );
          },
        },
        {
          key: 'removeItem',
          value: function (e) {
            var t = $.Deferred();
            return (
              this.addActionToQueue({
                action: 'removeItem',
                variantID: e,
                defer: t,
              }),
              t
            );
          },
        },
        {
          key: 'removeItemAction',
          value: function (e) {
            var t = $.Deferred();
            return (
              this.updateItemAction(e, 0).then(function () {
                t.resolve();
              }),
              t
            );
          },
        },
        {
          key: 'updateItem',
          value: function (e, t) {
            var o = $.Deferred();
            return (
              this.addActionToQueue({
                action: 'updateItem',
                variantID: e,
                quantity: t,
                defer: o,
              }),
              o
            );
          },
        },
        {
          key: 'updateItemAction',
          value: function (e, t) {
            var o = this,
              i = $.Deferred();
            return (
              $.ajax({
                type: 'post',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                  quantity: t,
                  id: e,
                },
                success: function (e) {
                  o.updateCart(e), i.resolve();
                },
                error: function (e) {
                  console.log('error'), console.log(e), i.reject(o.getErrorResponse(e));
                },
              }),
              i
            );
          },
        },
      ]),
      t
    );
  })(),
  Utility = (function () {
    function e() {
      _classCallCheck(this, e);
    }
    return (
      _createClass(e, null, [
        {
          key: 'debounce',
          value: function (i, n, a) {
            var s = void 0;
            return function () {
              var e = this,
                t = arguments,
                o = a && !s;
              clearTimeout(s),
                (s = setTimeout(function () {
                  (s = null), a || i.apply(e, t);
                }, n)),
                o && i.apply(e, t);
            };
          },
        },
      ]),
      e
    );
  })(),
  VariantSelector = (function (e) {
    function n(e, t) {
      _classCallCheck(this, n);
      var o = _possibleConstructorReturn(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this)),
        i = o;
      return (
        (i.container = 'object' === (void 0 === t ? 'undefined' : _typeof(t)) ? t : $('body')),
        (i.index = e),
        i.setKey(),
        i.setElements(),
        i.getElements().length
          ? (i.setWrapper(),
            i.setType(),
            i.setOptions(),
            i.setValue(),
            i.elements.on('change', function () {
              i.setValue(), i.emit('change');
            }),
            o)
          : _possibleConstructorReturn(o)
      );
    }
    return (
      _inherits(n, EventEmitter),
      _createClass(n, [
        {
          key: 'getKey',
          value: function () {
            return this.key;
          },
        },
        {
          key: 'setKey',
          value: function () {
            this.key = 'option' + this.index;
          },
        },
        {
          key: 'getElements',
          value: function () {
            return this.elements;
          },
        },
        {
          key: 'setElements',
          value: function () {
            this.elements = this.container.find('[data-single-option-selector][data-index="' + (this.index + 1) + '"]');
          },
        },
        {
          key: 'getWrapper',
          value: function () {
            return this.wrapper;
          },
        },
        {
          key: 'setWrapper',
          value: function () {
            this.wrapper = this.elements.parent();
          },
        },
        {
          key: 'getType',
          value: function () {
            return this.type;
          },
        },
        {
          key: 'setType',
          value: function () {
            this.type = 'INPUT' === this.elements.prop('tagName') ? this.elements.attr('type') : this.elements.prop('tagName').toLowerCase();
          },
        },
        {
          key: 'getOptions',
          value: function () {
            return this.options;
          },
        },
        {
          key: 'setOptions',
          value: function () {
            var t = this;
            (t.options = []),
              'radio' === t.type || 'checkbox' === t.type
                ? t.elements.each(function () {
                    var e = $(this).val();
                    t.options.push(e);
                  })
                : 'select' === t.type &&
                  t.elements.find('option').each(function () {
                    var e = $(this).val();
                    -1 === t.options[e] && t.options.push(e);
                  });
          },
        },
        {
          key: 'getValue',
          value: function () {
            return this.value;
          },
        },
        {
          key: 'setValue',
          value: function (e) {
            var t = this;
            e
              ? ('radio' === t.type || 'checkbox' === t.type
                  ? t.elements.each(function () {
                      $(this).prop('checked', $(this).val() === String(e));
                    })
                  : t.elements.val(e),
                (t.value = e))
              : 'radio' === t.type || 'checkbox' === t.type
              ? (t.value = t.elements.filter(':checked').val())
              : (t.value = t.elements.val());
          },
        },
        {
          key: 'setAvailableValues',
          value: function (t) {
            var e = this,
              o = null;
            if (
              ((o = 'radio' === e.type || 'checkbox' === e.type ? e.elements : e.elements.find('option')) &&
                o.each(function () {
                  var e = String($(this).val());
                  t.hasOwnProperty(e) ? ($(this).removeClass('unavailable'), t[e] ? ($(this).prop('disabled', !1), $(this).removeClass('sold-out')) : ($(this).prop('disabled', !0), $(this).addClass('sold-out'))) : ($(this).prop('disabled', !0), $(this).addClass('unavailable'));
                }),
              o.filter(':checked').prop('disabled'))
            ) {
              var i = null;
              o.each(function () {
                if ($(this).is(':enabled')) return (i = $(this).val()), !1;
                i || $(this).hasClass('unavailable') || (i = $(this).val());
              });
              // This avoids overwritting the selected variant if it's out of stock for the first available variant
              // , i && e.setValue(i)
            }

            // Commenting this out to
            // -1 <
            // Object.keys(t)
            //   .map(function (e) {
            //     return t[e];
            //   })
            //   .indexOf(!0)
            //   ? e.getWrapper()?.removeClass('unavailable')
            //   : e.getWrapper()?.addClass('unavailable'),
            //   'radio' !== e.type && 'checkbox' !== e.type && e.elements.trigger('custom.change');
          },
        },
      ]),
      n
    );
  })(),
  ComponentQuantitySelector = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return (
        (t.quantityRemove = t.component.find('.js-quantity-remove')),
        (t.quantityAdd = t.component.find('.js-quantity-add')),
        (t.quantity = t.component.find('input')),
        (t.min = t.quantity.attr('min') ? parseInt(t.quantity.attr('min')) : 0),
        (t.max = t.quantity.attr('max') ? parseInt(t.quantity.attr('max')) : -1),
        t.initQuantitySelector(),
        t
      );
    }
    return (
      _inherits(o, AbstractComponent),
      _createClass(o, [
        {
          key: 'initQuantitySelector',
          value: function () {
            var e = this;
            e.quantityRemove.on('click', function () {
              e.removeQuantity();
            }),
              e.quantityAdd.on('click', function () {
                e.addQuantity();
              }),
              e.quantity.on('change paste keyup', function () {
                e.cleanQuantitySelector();
              });
          },
        },
        {
          key: 'cleanQuantitySelector',
          value: function () {
            var e = parseInt(this.quantity.val());
            return (e = 1 < e ? e : 1), this.quantity.val(e), e;
          },
        },
        {
          key: 'removeQuantity',
          value: function () {
            var e = this.cleanQuantitySelector();
            (e = e > this.min ? --e : this.min), this.quantity.val(e);
          },
        },
        {
          key: 'addQuantity',
          value: function () {
            var e = this.cleanQuantitySelector();
            (e = 0 < e ? ++e : 1), this.quantity.val(e);
          },
        },
      ]),
      o
    );
  })(),
  ComponentSortBy = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return (t.select = t.component.find('select')), (t.options = t.component.find('option')), t.setJSSelect(), t;
    }
    return (
      _inherits(o, AbstractComponent),
      _createClass(o, [
        {
          key: 'setJSSelect',
          value: function () {
            var t = this;
            if (t.select.is(':disabled')) return !1;
            (t.jsSelect = $('<div class="js-select" role="button"><div class="selector"><span class="sort-by-toggle">Sort By</span></div><ul class="options"></ul></div>')),
              (t.jsSelectOpen = !1),
              (t.jsSelectSelector = t.jsSelect.find('.selector')),
              (t.jsSelectLabel = t.jsSelect.find('.label')),
              (t.jsSelectOptions = t.jsSelect.find('.options')),
              t.jsSelectOptions.html(''),
              t.options.each(function () {
                var e = $('<li role="button" data-value="' + $(this).val() + '">' + $(this).html() + '</li>');
                t.jsSelectOptions.append(e),
                  e.bind('click.js-select-option', function () {
                    $(this).hasClass('disabled') || $(this).hasClass('selected') || (t.select.val($(this).data('value')), t.select.trigger('change')), t.closeJSSelect();
                  });
              }),
              t.syncJSSelect(),
              t.select.on('change custom.change', function () {
                t.syncJSSelect();
              }),
              t.jsSelectSelector.on('click', function () {
                t.jsSelectOpen ? t.closeJSSelect() : t.openJSSelect();
              }),
              t.jsPlaceholder = t.component.find('.js-select-placeholder'),
              t.jsPlaceholder.html(t.jsSelect);
          },
        },
        {
          key: 'syncJSSelect',
          value: function () {
            this.syncOptions(), this.syncValue();
          },
        },
        {
          key: 'syncOptions',
          value: function () {
            var t = this;
            t.options.each(function () {
              var e = t.jsSelectOptions.find('[data-value="' + $(this).val() + '"]');
              e.toggleClass('disabled', $(this).is(':disabled')), e.toggleClass('selected', $(this).is(':selected'));
            });
          },
        },
        {
          key: 'syncValue',
          value: function () {
            this.jsSelectLabel.html(this.select.find('option:selected').text());
          },
        },
        {
          key: 'openJSSelect',
          value: function () {
            var t = this;
            t.jsSelect.addClass('open'),
              (t.jsSelectOpen = !0),
              setTimeout(function () {
                $('body')
                  .unbind('click.js-toggle')
                  .bind('click.js-toggle', function (e) {
                    $(e.target).parents('.component-select').length || t.closeJSSelect();
                  });
              });
          },
        },
        {
          key: 'closeJSSelect',
          value: function () {
            this.jsSelect.removeClass('open'), (this.jsSelectOpen = !1), $('body').unbind('click.js-toggle');
          },
        },
      ]),
      o
    );
  })(),
  ComponentSelect = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return (t.select = t.component.find('select')), (t.options = t.component.find('option')), t.setJSSelect(), t;
    }
    return (
      _inherits(o, AbstractComponent),
      _createClass(o, [
        {
          key: 'setJSSelect',
          value: function () {
            var t = this;
            if (t.select.is(':disabled')) return !1;
            (t.jsSelect = $('<div class="js-select" role="button"><div class="selector"><span class="label"></span></div><ul class="options"></ul></div>')),
              (t.jsSelectOpen = !1),
              (t.jsSelectSelector = t.jsSelect.find('.selector')),
              (t.jsSelectLabel = t.jsSelect.find('.label')),
              (t.jsSelectOptions = t.jsSelect.find('.options')),
              t.jsSelectOptions.html(''),
              t.options.each(function () {
                var e = $('<li role="button" data-value="' + $(this).val() + '">' + $(this).html() + '</li>');
                t.jsSelectOptions.append(e),
                  e.bind('click.js-select-option', function () {
                    $(this).hasClass('disabled') || $(this).hasClass('selected') || (t.select.val($(this).data('value')), t.select.trigger('change')), t.closeJSSelect();
                  });
              }),
              t.syncJSSelect(),
              t.select.on('change custom.change', function () {
                t.syncJSSelect();
              }),
              t.jsSelectSelector.on('click', function () {
                t.jsSelectOpen ? t.closeJSSelect() : t.openJSSelect();
              }),
              t.component.prepend(t.jsSelect);
          },
        },
        {
          key: 'syncJSSelect',
          value: function () {
            this.syncOptions(), this.syncValue();
          },
        },
        {
          key: 'syncOptions',
          value: function () {
            var t = this;
            t.options.each(function () {
              var e = t.jsSelectOptions.find('[data-value="' + $(this).val() + '"]');
              e.toggleClass('disabled', $(this).is(':disabled')), e.toggleClass('selected', $(this).is(':selected'));
            });
          },
        },
        {
          key: 'syncValue',
          value: function () {
            this.jsSelectLabel.html(this.select.find('option:selected').text());
          },
        },
        {
          key: 'openJSSelect',
          value: function () {
            var t = this;
            t.jsSelect.addClass('open'),
              (t.jsSelectOpen = !0),
              setTimeout(function () {
                $('body')
                  .unbind('click.js-toggle')
                  .bind('click.js-toggle', function (e) {
                    $(e.target).parents('.component-select').length || t.closeJSSelect();
                  });
              });
          },
        },
        {
          key: 'closeJSSelect',
          value: function () {
            this.jsSelect.removeClass('open'), (this.jsSelectOpen = !1), $('body').unbind('click.js-toggle');
          },
        },
      ]),
      o
    );
  })(),
  ComponentVideo = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return (t.video = t.component.find('video')), (t.containerAspectRatio = 1), (t.videoAspectRatio = 1), t.setVideoAspectRatio(), t.initVideoCover(), t.initVideo(), t;
    }
    return (
      _inherits(o, AbstractComponent),
      _createClass(o, [
        {
          key: 'setVideoAspectRatio',
          value: function () {
            this.videoAspectRatio = (this.video.prop('width') / this.video.prop('height')).toFixed(4);
          },
        },
        {
          key: 'initVideoCover',
          value: function () {
            var t = this;
            t.setVideoFillMode(),
              $(window).on(
                'resize',
                Foundation.util.throttle(function (e) {
                  t.setVideoFillMode();
                }, 20)
              );
          },
        },
        {
          key: 'setVideoFillMode',
          value: function () {
            var e = this;
            (e.containerAspectRatio = (e.component.outerWidth() / e.component.outerHeight()).toFixed(4)),
              e.containerAspectRatio > e.videoAspectRatio ? (e.component.removeClass('fill-height'), e.component.addClass('fill-width')) : (e.component.removeClass('fill-width'), e.component.addClass('fill-height'));
          },
        },
        {
          key: 'initVideo',
          value: function () {
            this.component.addClass('initialised');
          },
        },
        {
          key: 'playVideo',
          value: function () {
            this.video[0].play();
          },
        },
        {
          key: 'pauseVideo',
          value: function () {
            this.video[0].pause();
          },
        },
        {
          key: 'checkVideoLoad',
          value: function () {
            4 === this.video[0].readyState ? this.component.addClass('initialised') : setTimeout(this.checkVideoLoad(), 100);
          },
        },
      ]),
      o
    );
  })(),
  CartCountSnippet = (function (e) {
    function i(e) {
      _classCallCheck(this, i);
      var t = _possibleConstructorReturn(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this, e)),
        o = t;
      return (
        (t.quantity = t.snippet.find('span')),
        AppShopifyCart.on('cart.update', function () {
          var e = AppShopifyCart.getItemCount();
          0 < e ? (o.snippet.addClass('has-items'), o.quantity.html(e)) : (o.snippet.removeClass('has-items'), o.quantity.html(''));
        }),
        t
      );
    }
    return _inherits(i, AbstractSnippet), i;
  })(),
  CartModalSnippet = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initVue(), t.initJSToggles(), t;
    }
    return (
      _inherits(o, AbstractSnippet),
      _createClass(o, [
        {
          key: 'initVue',
          value: function () {
            var e = this;
            Vue.filter('formatMoney', function (e) {
              return e ? slate.Currency.formatMoney(e, theme.moneyFormat) : '';
            }),
              Vue.filter('formatImageSize', function (e, t) {
                return e && t ? slate.Image.getSizedImageUrl(e, t) : '';
              }),
              Vue.component('product-item', {
                template:
                  '                <li class="product grid-x align-top" :class="{ loading: loading }">                    <div v-if="image" class="product-image">                        <a :href="url"><img :src="image | formatImageSize(\'medium\')"></a>                    </div>                    <div class="product-details grid-y flex-child-auto">                        <h6><a :href="url">{{ title }}</a></h6>                        <span>{{ price | formatMoney }}</span>                        <span><template v-for="(option, index) in variant_options">{{index > 0 ? \' / \' : \'\'}}{{ option }}</template></span>                        <span>Quantity: {{ quantity }}</span>                        <span><a class="product-remove" v-on:click="remove">Remove</a></span>                    </div>                </li>                ',
                props: ['id', 'title', 'quantity', 'image', 'url', 'price', 'variant_options'],
                data: function () {
                  return {
                    loading: !1,
                  };
                },
                methods: {
                  remove: function () {
                    var e = this;
                    e.loading ||
                      ((e.loading = !0),
                      AppShopifyCart.removeItem(this.id).then(function () {
                        e.loading = !1;
                      }));
                  },
                },
              }),
              (e.vm = new Vue({
                el: e.snippet.find('.cart-modal-view')[0],
                delimiters: ['${', '}'],
                data: {
                  cart: AppShopifyCart.getCart(),
                  open: !1,
                },
              })),
              AppShopifyCart.on('cart.update', function () {
                e.vm.cart = AppShopifyCart.getCart();
              });
          },
        },
        {
          key: 'isCartOpen',
          value: function () {
            return this.vm.open;
          },
        },
        {
          key: 'openCart',
          value: function () {
            var t = this;
            (this.vm.open = !0),
              Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 640 && ((t.scrollPosition = window.pageYOffset), window.scrollTo(0, 0), $('body').addClass('phone-fixed-header')),
              setTimeout(function () {
                $('body')
                  .unbind('click.js-cart-modal')
                  .bind('click.js-cart-modal', function (e) {
                    $(e.target).parents('.cart-modal').length || $(e.target).hasClass('cart-modal') || $(e.target).hasClass('js-toggle-cart-modal') || t.closeCart();
                  });
              });
          },
        },
        {
          key: 'closeCart',
          value: function () {
            (this.vm.open = !1),
              this.jsCartToggles.removeClass('active'),
              HeaderSection.unlockHeader(),
              Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 640 && ($('body').removeClass('phone-fixed-header'), window.scrollTo(0, this.scrollPosition)),
              $('body').unbind('click.js-cart-modal');
          },
        },
        {
          key: 'initJSToggles',
          value: function () {
            var t = this;
            (t.jsCartToggles = $('.js-toggle-cart-modal')),
              t.jsCartToggles.bind('click.js-cart-modal', function (e) {
                e.preventDefault(), t.jsCartToggles.removeClass('active'), t.isCartOpen() ? t.closeCart() : (t.openCart(), $(this).addClass('active'), HeaderSection.lockHeader());
              }),
              (t.cartCloseButton = t.snippet.find('.close-cart')),
              t.cartCloseButton.click(function () {
                t.closeCart();
              }),
              AppShopifyCart.on('cart.add', function () {
                HeaderSection.maximiseHeader(), t.jsCartToggles.removeClass('active'), t.isCartOpen() ? t.closeCart() : (t.openCart(), t.jsCartToggles.addClass('active'));
              });
          },
        },
      ]),
      o
    );
  })(),
  CollectionFilterSnippet = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initFilter(), t.initFilterToggle(), t.initFilterCategoryToggle(), t.initReset(), t.initFilterAccordion(), t;
    }
    return (
      _inherits(o, AbstractSnippet),
      _createClass(o, [
        {
          key: 'initFilter',
          value: function () {
            var e = this;
            (e.filters = e.snippet.find('.filter input[type="radio"]')),
              e.filters.on('change', function () {
                e.reloadPage();
              });
          },
        },
        {
          key: 'initFilterToggle',
          value: function () {
            (this.filterTitles = this.snippet.find('.filter-title')),
              this.filterTitles.on('click', function () {
                $(this).next('.filter').slideToggle();
              });
          },
        },
        {
          key: 'initFilterCategoryToggle',
          value: function () {
            (this.categoryToggles = this.snippet.find('.toggle-category')),
              this.categoryToggles.on('click', function () {
                $(this).parent().toggleClass('open');
              });
          },
        },
        {
          key: 'initReset',
          value: function () {
            var t = this;
            (t.resetButtons = t.snippet.find('.reset')),
              t.resetButtons.on('click', function () {
                var e = $(this).data('name');
                t.snippet.find('input[name=' + e + ']').attr('checked', !1), t.reloadPage();
              });
          },
        },
        {
          key: 'reloadPage',
          value: function () {
            var e = [],
              t = '';
            if (
              (this.filters.each(function () {
                $(this)[0].checked && e.push($(this).val());
              }),
              (Shopify.queryParams = {}),
              location.search.length)
            )
              for (var o, i = 0, n = location.search.substr(1).split('&'); i < n.length; i++) 1 < (o = n[i].split('=')).length && (t = '?' + decodeURIComponent(o[0]) + '=' + decodeURIComponent(o[1]));
            if (e.length) {
              var a = e.join('+');
              window.location.href = '/collections/' + this.snippet.data('collection') + '/' + a + t;
            } else window.location.href = '/collections/' + this.snippet.data('collection') + t;
          },
        },
        {
          key: 'initFilterAccordion',
          value: function () {
            var e = this;
            (e.accordion = e.snippet.find('.accordion')),
              (e.accordionItems = e.snippet.find('.accordion-content')),
              (e.colourRadio = e.snippet.find("input[name='colour']")),
              (e.sizeRadio = e.snippet.find("input[name='size']")),
              e.filters.each(function () {
                $(this)[0].checked && $(this).closest('.accordion-item').addClass('is-active');
              }),
              new Foundation.ResponsiveAccordionTabs(e.accordion),
              Foundation.MediaQuery.atLeast('medium') && e.accordion.foundation('toggle', e.accordion.find('.accordion-content').first());
          },
        },
      ]),
      o
    );
  })(),
  SearchAutocompleteSnippet = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return (t.scrollPosition = 0), (t.body = $('body')), t.initVue(), t.initFocusSearch(), t;
    }
    return (
      _inherits(o, AbstractSnippet),
      _createClass(o, [
        {
          key: 'initVue',
          value: function () {
            var i = this;
            Vue.component('result-product-item', {
              template:
                '        <li class="result result-product-item cell small-4">          <a :href="url">            <div v-if="image" class="result-item-image" :style="{ backgroundImage: \'url(\' + image + \')\' }"></div>            <div class="details">              <h6>{{ title }}</h6>            </div>          </a>        </li>        ',
              props: ['title', 'image', 'url'],
            }),
              Vue.component('result-page-item', {
                template:
                  '        <li class="result result-page-item cell small-4">          <a :href="url" class="grid-x align-left align-middle">            <div class="details cell auto">              <h6>{{ title }}</h6>              <p v-if="excerpt">{{ excerpt }}</p>            </div>          </a>        </li>        ',
                props: ['title', 'excerpt', 'url'],
              }),
              Vue.component('result-article-item', {
                template:
                  '        <li class="result result-article-item cell small-4">          <a :href="url" class="grid-x align-left align-middle">            <div v-if="image" class="result-item-image cell shrink" :style="{ backgroundImage: \'url(\' + image + \')\' }"></div>            <div class="details cell auto">              <h6>{{ title }}</h6>            </div>          </a>        </li>        ',
                props: ['title', 'image', 'url'],
              }),
              (i.lastRequest = null),
              (i.vm = new Vue({
                el: i.snippet.find('.search-autocomplete-view')[0],
                delimiters: ['${', '}'],
                data: {
                  keyword: '',
                  keyword_focused: !1,
                  results: [],
                  resultsCache: {},
                },
                watch: {
                  keyword: function (e, t) {
                    var o = e;
                    i.lastRequest && i.lastRequest.abort(), 2 < o.length ? this.updateResults(o) : this.clearResults();
                  },
                },
                methods: {
                  clearSearch: function () {
                    this.keyword = '';
                  },
                  updateResults: Utility.debounce(function (o) {
                    i.vm.resultsCache.hasOwnProperty(o)
                      ? (i.vm.results = i.vm.resultsCache[o])
                      : this.$http
                          .get('/search', {
                            params: {
                              q: o,
                              view: 'json',
                            },
                            before: function (e) {
                              i.lastRequest = e;
                            },
                          })
                          .then(
                            function (e) {
                              var t = e.body.results;
                              (i.vm.resultsCache[o] = t), (i.vm.results = t);
                            },
                            function (e) {}
                          );
                  }, 200),
                  clearResults: function () {
                    i.vm.results = [];
                  },
                  setInputBlur: function () {
                    this.$refs.keyword.blur();
                  },
                  inputFocus: function () {
                    console.log('inputFocus'),
                      (this.keyword_focused = !0),
                      HeaderSection.lockHeader(),
                      $('[ss-autocomplete]').removeClass('hide'),
                      (i.scrollPosition = window.pageYOffset),
                      i.body.addClass('search-autocomplete-active'),
                      setTimeout(function () {
                        HeaderSection.initMobileSearch();
                      }, 200);
                  },
                  inputBlur: function () {
                    console.log('inputBlur');
                  },
                },
              }));
          },
        },
        {
          key: 'initFocusSearch',
          value: function () {
            var e = this;
            $('.js-focus-search-autocomplete')
              .unbind('click')
              .bind('click', function () {
                console.log('search click'), e.vm.$refs.keyword.focus(), $(window).width() < 1024 && (document.body.classList.contains('search-autocomplete-active') || (console.log('show search bar'), HeaderSection.showSearchBar()));
              });
          },
        },
      ]),
      o
    );
  })(),
  AccordionTabsSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initAccordionTabs(), t.initToggle(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initAccordionTabs',
          value: function () {
            var e = this;
            (e.accordion = e.section.find('.accordion')), (e.accordionItems = e.accordion.find('.accordion-content')), new Foundation.ResponsiveAccordionTabs(e.accordion);
          },
        },
        {
          key: 'initToggle',
          value: function () {
            var o = this;
            (o.toggleButton = o.section.find('.js-toggle-all')),
              o.toggleButton.length &&
                ((o.toggleLabelExpand = o.toggleButton.find('.label-expand')),
                (o.toggleLabelCollapse = o.toggleButton.find('.label-collapse')),
                o.updateToggleState(),
                o.accordion.on('down.zf.accordion', function () {
                  o.updateToggleState();
                }),
                o.accordion.on('up.zf.accordion', function () {
                  o.updateToggleState();
                }),
                o.toggleButton.on('click', function () {
                  o.accordionItems.each(function (e, t) {
                    'expand' === o.toggleState ? o.accordion.foundation('down', $(t)) : 'collapse' === o.toggleState && o.accordion.foundation('up', $(t));
                  });
                }));
          },
        },
        {
          key: 'updateToggleState',
          value: function () {
            var e = this;
            1 < e.accordion.find('.accordion-content[aria-hidden="false"]').length
              ? (e.toggleLabelExpand.addClass('hide'), e.toggleLabelCollapse.removeClass('hide'), (e.toggleState = 'collapse'))
              : (e.toggleLabelExpand.removeClass('hide'), e.toggleLabelCollapse.addClass('hide'), (e.toggleState = 'expand'));
          },
        },
      ]),
      o
    );
  })(),
  AlsoBoughtSection = (function (e) {
    function r(e) {
      return _classCallCheck(this, r), _possibleConstructorReturn(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));
    }
    return (
      _inherits(r, AbstractSection),
      _createClass(r, null, [
        {
          key: 'alsoBoughtCallback',
          value: function (o, e) {
            var i = o.find('.products-container'),
              n = o.find('.products-container__slider');
            if ('object' !== (void 0 === e ? 'undefined' : _typeof(e)) || 0 === e.length || !e[0].hasOwnProperty('products')) return !1;
            for (var t = e[0].products, a = [], s = 0; s < t.length; s++) a.push(t[s].url);
            if (0 === a.length) return !1;
            $.ajax({
              type: 'get',
              url: '/collections?products=' + a.join(','),
              dataType: 'html',
              data: {
                view: 'items',
                cache: 'false',
              },
              success: function (e) {
                if (0 < (e = JSON.parse(e)).product_count) {
                  for (var t = 0; t < e.products_html.length; t++) n.append(e.products_html[t]);
                  setTimeout(function () {
                    ShopifyApp.refreshProducts();
                  }, 100),
                    o.addClass('loaded'),
                    r.initSlider(n, i);
                }
              },
              error: function (e) {
                console.log('error'), console.log(e);
              },
            });
          },
        },
        {
          key: 'initSlider',
          value: function (e, t) {
            e.on('breakpoint', function (e, t, o, i) {
              ShopifyApp.refreshProducts();
            }),
              e.on('init', function (e, t, o, i) {
                ShopifyApp.refreshProducts();
              }),
              e.on('beforeChange', function (event, slick, direction) {
                ShopifyApp.refreshProducts();
              }),
              e.slick({
                infinite: !1,
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: t.find('.slick-prev'),
                nextArrow: t.find('.slick-next'),
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: !1,
                      dots: !0,
                    },
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      arrows: !1,
                      dots: !0,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3,
                    },
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                    },
                  },
                ],
              });
          },
        },
      ]),
      r
    );
  })();
window.cbbJsonpCallbackpreferencesalso_bought = function (e) {
  var t = $('.section-also-bought');
  t.length && AlsoBoughtSection.alsoBoughtCallback(t, e);
};
var BannerSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            var e = this.section.find('.banner__slider'),
              t = e.find('.slide');
            e.length && 1 < t.length
              ? (e.on('init', function (e, t) {
                  $(t.$slides[t.currentSlide]).addClass('slide-animate');
                }),
                e.on('beforeChange', function (e, t, o, i) {
                  $(t.$slides[t.currentSlide]).removeClass('slide-animate'), $(t.$slides[i]).addClass('slide-animate');
                }),
                e.slick({
                  infinite: !0,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  fade: !0,
                  autoplay: !0,
                  autoplaySpeed: 9e3,
                  prevArrow: this.section.find('.slick-prev'),
                  nextArrow: this.section.find('.slick-next'),
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        arrows: !1,
                      },
                    },
                  ],
                }))
              : t.addClass('slide-animate');
          },
        },
      ]),
      o
    );
  })(),
  CartSection = (function (e) {
    function t(e) {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    }
    return _inherits(t, AbstractSection), t;
  })(),
  CollectionSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSelectors(), t.initColumnToggle(), t.initSorting(), t.initScrollPosition(), loadMoreEnable ? t.initInfiniteScroll() : t.initLoadMore(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSelectors',
          value: function () {
            (this.itemContainerSelector = '#collection-infinite-container'), (this.itemContainer = this.section.find(this.itemContainerSelector)), (this.productsPerPage = this.itemContainer.data('products-per-page')), (this.pagination = this.section.find('.pagination-collection'));
          },
        },
        {
          key: 'initColumnToggle',
          value: function () {
            var e = this;
            (this.collectionColumns = 4),
              (this.collection3Col = this.section.find('.column-toggle_3col')),
              (this.collection4Col = this.section.find('.column-toggle_4col')),
              (this.sortby = this.section.find('#sort-by')),
              (this.filters = this.section.find('.filter input[type="radio"]')),
              this.collection3Col.on('click', function () {
                4 === e.collectionColumns && ((e.collectionColumns = 3), e.collection4Col.removeClass('is-active'), e.collection3Col.addClass('is-active'), e.toggleColumns());
              }),
              this.collection4Col.on('click', function () {
                3 === e.collectionColumns && ((e.collectionColumns = 4), e.collection3Col.removeClass('is-active'), e.collection4Col.addClass('is-active'), e.toggleColumns());
              });
          },
        },
        {
          key: 'toggleColumns',
          value: function () {
            var e = this.section.find('.collection-products');
            3 === this.collectionColumns ? e.removeClass('collection-grid-4').addClass('collection-grid-3') : e.removeClass('collection-grid-3').addClass('collection-grid-4');
          },
        },
        {
          key: 'initSorting',
          value: function () {
            var e = this;
            if (((Shopify.queryParams = {}), location.search.length)) for (var t, o = 0, i = location.search.substr(1).split('&'); o < i.length; o++) 1 < (t = i[o].split('=')).length && (Shopify.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]));
            this.sortby.on('change', function () {
              (Shopify.queryParams.sort_by = e.sortby.val()), (location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20'));
            });
          },
        },
        {
          key: 'initScrollPosition',
          value: function () {
            var e = this;
            this.scrollPositionInput = this.section.find('#collection-scroll-position');
            var t = this.scrollPositionInput.val();
            0 < (t = 0 < t ? t : 0) &&
              $('html,body').animate(
                {
                  scrollTop: t,
                },
                0
              ),
              $(window).scroll(
                Foundation.util.throttle(function () {
                  return e.scrollPositionInput.val($(window).scrollTop());
                }, 200)
              );
          },
        },
        {
          key: 'initInfiniteScroll',
          value: function () {
            var e = this;
            if (loadMoreEnable) {
              (this.collectionLoading = !1),
                (this.firstPage = !0),
                (this.loadMoreButtonSelector = '#collection-load-more-button'),
                (this.loadMoreContainer = this.section.find('#collection-load-more-container')),
                (this.loadMoreButton = this.section.find(this.loadMoreButtonSelector)),
                (this.defaultPagination = this.section.find('.pagination')),
                (this.maxPages = this.loadMoreButton.data('num-pages')),
                this.defaultPagination.hide(),
                this.loadMoreContainer.show();
              var t = function () {
                return e.loadMoreCheck();
              };
              this.loadMoreButton.on('click', t), $(window).scroll(Foundation.util.throttle(t, 400));
            }
          },
        },
        {
          key: 'initLoadMore',
          value: function () {
            //               26-08-19 if statement added to ensure loadMore function only fires when required.
            if ($('*[data-next-url]').length) {
              var t = this;
              (loadMoreEnable = !0),
                (this.collectionLoading = !1),
                (this.firstPage = !0),
                (this.loadMoreButtonSelector = '.js-load-more'),
                (this.loadMoreButton = this.section.find(this.loadMoreButtonSelector)),
                (this.maxPages = this.loadMoreButton.data('num-pages')),
                (this.defaultPagination = this.section.find('.pagination'));
              var o = this.loadMoreButton.data('next-url');
              (this.currentPage = parseInt(o.match(/page=([\d]+)/)[1], 10) - 1),
                this.loadMoreButton.on('click', function () {
                  var e = void 0;
                  t.currentPage < t.maxPages && (t.currentPage++, (e = o.replace(/page=([\d]+)/, 'page=' + t.currentPage)), t.loadMoreButton.attr('data-next-url', e), t.loadMoreButton.data('next-url', e)), t.loadNextPageProducts(e, t.firstPage);
                });
            }
          },
        },
        {
          key: 'loadMoreCheck',
          value: function () {
            this.itemContainer.offset().top + parseInt(this.itemContainer.outerHeight()) < $(window).scrollTop() + parseInt($(window).height()) && this.loadNextPageProducts(null, this.firstPage);
          },
        },
        {
          key: 'loadNextPageProducts',
          value: function (e) {
            var o = this;
            return (
              !this.collectionLoading &&
              ((this.collectionLoading = !0),
              loadMoreEnable && (e = this.loadMoreButton.data('next-url')),
              '' !== e
                ? $.ajax({
                    type: 'GET',
                    url: e,
                    dataType: 'html',
                    beforeSend: function () {
                      loadMoreEnable && (o.loadMoreButton.addClass('js-loading'), o.loadMoreButton.text(o.loadMoreButton.data('loading-text')));
                    },
                  })
                    .done(function (e) {
                      if (($(e).find('#collection-infinite-container > *').appendTo(o.itemContainer), loadMoreEnable)) {
                        var t = $(e).find(o.loadMoreButtonSelector).attr('data-next-url') || 'null';
                        (o.firstPage = !1), o.loadMoreButton.data('next-url', t), 'null' !== t ? (o.loadMoreButton.removeClass('js-loading'), o.loadMoreButton.text(o.loadMoreButton.data('load-more-text'))) : o.loadMoreButton.hide();
                      }
                      o.toggleColumns(), AppQuickview.initQuickViewButtons();
                    })
                    .always(function () {
                      (o.collectionLoading = !1), ShopifyApp.lazyLoadCheckDOM();
                    })
                : void (!0 === loadMoreEnable && this.loadMoreButton.hide()))
            );
          },
        },
      ]),
      o
    );
  })(),
  CustomerAddressesSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initAddresses(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initAddresses',
          value: function () {
            var t = this;
            (t.$newAddressForm = t.section.find('#AddressNewForm')),
              t.$newAddressForm.length &&
                (Shopify &&
                  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
                    hideElement: 'AddressProvinceContainerNew',
                  }),
                (t.$addresCountryOption = t.section.find('.address-country-option')),
                t.$addresCountryOption.each(function () {
                  var e = $(this).data('form-id'),
                    t = 'AddressCountry_' + e,
                    o = 'AddressProvince_' + e,
                    i = 'AddressProvinceContainer_' + e;
                  new Shopify.CountryProvinceSelector(t, o, {
                    hideElement: i,
                  });
                }),
                (t.$addressNewToggle = t.section.find('.address-new-toggle')),
                t.$addressNewToggle.on('click', function () {
                  t.$newAddressForm.toggleClass('hide');
                }),
                (t.$addressEditToggle = t.section.find('.address-edit-toggle')),
                t.$addressEditToggle.on('click', function () {
                  var e = $(this).data('form-id');
                  (t.$editAddress = t.section.find('#EditAddress_' + e)),
                    (t.$addressContainer = t.section.find('#AddressContainer_' + e)),
                    t.$addressContainer.hasClass('active') ||
                      ($('.existing-customer-address').each(function () {
                        $(this).removeClass('active');
                      }),
                      $('.edit-customer-address').each(function () {
                        $(this).addClass('hide');
                      })),
                    t.$addressContainer.toggleClass('active'),
                    t.$editAddress.toggleClass('hide');
                }),
                (t.$addressDelete = t.section.find('.address-delete')),
                t.$addressDelete.on('click', function () {
                  var e = $(this),
                    t = e.data('form-id'),
                    o = e.data('confirm-message');
                  confirm(o || 'Are you sure you wish to delete this address?') &&
                    Shopify.postLink('/account/addresses/' + t, {
                      parameters: {
                        _method: 'delete',
                      },
                    });
                }));
          },
        },
      ]),
      o
    );
  })(),
  FeaturedProductsSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            (this.sliderContainer = this.section.find('.products-container')),
              (this.slider = this.section.find('.products-container__slider')),
              this.slider.on('breakpoint', function (e, t, o, i) {
                ShopifyApp.refreshProducts();
              }),
              this.slider.on('beforeChange', function (event, slick, direction) {
                ShopifyApp.refreshProducts();
              }),
              this.slider.slick({
                infinite: !1,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: this.sliderContainer.find('.slick-prev'),
                nextArrow: this.sliderContainer.find('.slick-next'),
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: !0,
                      dots: !1,
                    },
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      arrows: !0,
                      dots: !1,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3,
                    },
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                    },
                  },
                ],
              });
          },
        },
      ]),
      o
    );
  })(),
  ShopTheLookSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            (this.sliderContainer = this.section.find('.products-container')),
              (this.slider = this.section.find('.products-container__slider')),
              this.slider.on('breakpoint', function (e, t, o, i) {
                ShopifyApp.refreshProducts();
              }),
              this.slider.on('beforeChange', function (event, slick, direction) {
                ShopifyApp.refreshProducts();
              }),
              this.slider.slick({
                infinite: !1,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: this.sliderContainer.find('.slick-prev'),
                nextArrow: this.sliderContainer.find('.slick-next'),
                arrows: !0,
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: !0,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3,
                    },
                  }
                ],
              });
          },
        },
      ]),
      o
    );
  })(),
  ImageTextCarousel = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            (this.sliderContainer = this.section.find('.image-text__carousel')),
              (this.slider = this.section.find('.image-text__carousel--inner')),
              this.slider.slick({
                infinite: !1,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: !0,
                prevArrow: this.sliderContainer.find('.slick-prev'),
                nextArrow: this.sliderContainer.find('.slick-next'),
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    },
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    },
                  }
                ],
              });
          },
        },
      ]),
      o
    );
  })(),
  WayfinderCarouselSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            (this.sliderContainer = this.section.find('.wayfinder-slider')),
              (this.slider = this.section.find('.wayfinder__slider')),
              this.slider.slick({
                infinite: !1,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: !0,
                prevArrow: this.sliderContainer.find('.slick-prev'),
                nextArrow: this.sliderContainer.find('.slick-next'),
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                    },
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                    },
                  }
                ],
              });
          },
        },
      ]),
      o
    );
  })(),
  ImageTextSingleCarousel = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            (this.sliderContainer = this.section.find('.image-text__carousel')),
              (this.slider = this.section.find('.image-text__carousel--inner')),
              this.slider.slick({
                infinite: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !0,
                prevArrow: this.sliderContainer.find('.slick-prev'),
                nextArrow: this.sliderContainer.find('.slick-next'),
              });
          },
        },
      ]),
      o
    );
  })(),
  HeaderSection = (function (e) {
    function i(e) {
      _classCallCheck(this, i);
      var t = _possibleConstructorReturn(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this, e));
      return (t.navOpen = !1), (t.scrollPosition = 0), (t.body = $('body')), t.initStickyHeader(), t.initMobileNavigation(), (t.autocomplete = $('[ss-autocomplete]')), t;
    }
    return (
      _inherits(i, AbstractSection),
      _createClass(
        i,
        [
          {
            key: 'initMobileNavigation',
            value: function () {
              var e = this;
              $('.js-mobile-nav-toggle').click(function () {
                e.navOpen
                  ? (e.body.removeClass('main-nav-active'),
                    e.body.css({
                      top: '',
                    }),
                    window.scrollTo(0, e.scrollPosition),
                    (e.navOpen = !1))
                  : ((e.scrollPosition = window.pageYOffset),
                    e.body.addClass('main-nav-active'),
                    e.body.css({
                      top: -e.scrollPosition + 'px',
                    }),
                    (e.navOpen = !0)),
                  $('.nav-overlay').fadeToggle(200);
                var topBarToggle = $('.top-bar-item .js-mobile-nav-toggle');
                if (topBarToggle) {
                  topBarToggle.attr('aria-label', e.navOpen
                    ? topBarToggle.attr('data-aria-close') || 'Close menu'
                    : topBarToggle.attr('data-aria-open') || 'Open menu'
                  );
                }
              }),
                (e.mobileNav = $('.mobile-nav')),
                e.mobileNav.find('.toggle').on('click', function () {
                  $(this).parent().toggleClass('open');
                });
            },
          },
          {
            key: 'initStickyHeader',
            value: function () {
              const isMobile = window.innerWidth <= 768;

              if (isMobile) {
                if (!window.theme.enableStickyHeaderMobile) { return };
              } else {
                if (!window.theme.enableStickyHeader) { return };
              }

              var t,
                o = this;
              (o.scrollTopPrev = $(this).scrollTop()),
                $(window).scroll(
                  Foundation.util.throttle(function () {
                    var e = $(this).scrollTop();
                    i.isLockedHeader() || (50 < e ? i.compactHeader() : i.expandHeader()), (t = !0), (o.scrollTop = e);
                  }, 20)
                ),
                setInterval(function () {
                  t &&
                    ((function () {
                      var e,
                        t = $(this).scrollTop();
                      e = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1024 ? 50 : 120;
                      Math.abs(t - o.scrollTopPrev);
                      t <= e ? i.maximiseHeader() : t > o.scrollTopPrev ? i.minimiseHeader() : t < o.scrollTopPrev && i.maximiseHeader();
                      o.scrollTopPrev = $(this).scrollTop();
                    })(),
                    (t = !1));
                }, 250),
                $(window).scroll();
            },
          },
        ],
        [
          {
            key: 'isLockedHeader',
            value: function () {
              return $('body').hasClass('lock-header');
            },
          },
          {
            key: 'keepLocked',
            value: function () {
              return $('body').hasClass('keep-lock');
            },
          },
          {
            key: 'unlockHeader',
            value: function () {
              i.keepLocked() ? $('body').removeClass('keep-lock') : $('body').removeClass('lock-header');
            },
          },
          {
            key: 'lockHeader',
            value: function () {
              i.isLockedHeader() ? $('body').addClass('keep-lock') : $('body').addClass('lock-header');
            },
          },
          {
            key: 'expandHeader',
            value: function () {
              $('body').removeClass('compact-header');
            },
          },
          {
            key: 'compactHeader',
            value: function () {
              $('body').addClass('compact-header');
            },
          },
          {
            key: 'minimiseHeader',
            value: function () {
              $('body').addClass('minimise-header');
            },
          },
          {
            key: 'maximiseHeader',
            value: function () {
              $('body').removeClass('minimise-header');
            },
          },
          {
            key: 'showSearchBar',
            value: function () {
              console.log('showSearchBar'), $('.search-bar-mobile').slideDown(100), $('.search-bar-mobile input[type="search"]').focus();
            },
          },
          {
            key: 'initMobileSearch',
            value: function () {
              console.log('init hide search'),
                $(document)
                  .unbind('click')
                  .bind('click', function (e) {
                    console.log(e.target),
                      ($('.search-bar-mobile')[0].contains(e.target) && !$(e.target).hasClass('search-autocomplete-clear')) ||
                        ($('body').hasClass('search-autocomplete-active') &&
                          setTimeout(function () {
                            i.unlockHeader(), $('[ss-autocomplete]').addClass('hide'), i.hideSearchBar(), $('body').removeClass('search-autocomplete-active');
                          }, 200));
                  }),
                $('.search-bar-mobile [type="submit"]')
                  .unbind('click')
                  .bind('click', function () {
                    $('.search-bar-mobile .search-autocomplete-view').submit();
                  });
            },
          },
          {
            key: 'hideSearchBar',
            value: function () {
              $(document).unbind('click'), $('.search-bar-mobile').slideUp(100);
            },
          },
        ]
      ),
      i
    );
  })(),
  NewsletterSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.submitNewsletter(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'submitNewsletter',
          value: function () {
            var t = this;
            (t.form = t.section.find('#mc-embedded-subscribe-form')),
              0 < t.form.length &&
                t.form.bind('submit', function (e) {
                  e && (e.preventDefault(), t.register());
                });
          },
        },
        {
          key: 'register',
          value: function (e) {
            var t = this;
            $.ajax({
              type: 'GET',
              url: t.form.attr('action'),
              data: t.form.serialize(),
              dataType: 'jsonp',
              error: function (e) {
                alert('Could not connect to the registration server. Please try again later.');
              },
              success: function (e) {
                'success' == e.result &&
                  (t.section.find('.section-title').remove(),
                  t.form.html('<h2 class="text-center">Thank you for subscribing</h2><p class="text-center">We have sent you a confirmation email.</p>'),
                  (t.modal = t.section.find('#newsletterModal')),
                  (t.modalContent = t.modal.find('.modal-content')),
                  t.modal.foundation(),
                  t.modal.foundation('open'),
                  t.modalContent.html('<h2>Thank you for subscribing</h2><p>We have sent you a confirmation email.</p><a data-close aria-label="Close" class="button button-primary button-solid">Ok</a>'),
                  t.section.find('#subscribe-result').remove()),
                  'error' == e.result && t.section.find('#subscribe-result').html('<p>' + e.msg + '</p>');
              },
            });
          },
        },
      ]),
      o
    );
  })(),
  OffersSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            var e = this;
            if (((e.slider = e.section.find('.slider')), !e.slider.length)) return !1;
            $(window).on('changed.zf.mediaquery', function () {
              e.updateSlider();
            }),
              e.updateSlider();
          },
        },
        {
          key: 'updateSlider',
          value: function () {
            Foundation.MediaQuery.atLeast('medium')
              ? this.slider.hasClass('slick-initialized') && this.slider.slick('unslick')
              : this.slider.slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: !1,
                  arrows: !1,
                  dots: !1,
                  fade: !0,
                  pauseOnFocus: !1,
                  pauseOnHover: !1,
                  autoplay: !0,
                  autoplaySpeed: 4e3,
                  swipe: !1,
                });
          },
        },
      ]),
      o
    );
  })(),
  /*
   * =========
   * TWP NOTES
   * =========
   * This section is now handled directly in frontend/scripts/templates/product.js
   *
   * To completely remove this commented out section after we migrate
   * this entire old mangled file new standards
   */
  /*
  ProductSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initImageSlider(), t.initProduct(), t.initProductTabs(), t.initAfterPayModal(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initImageSlider',
          value: function () {
            var e = this;
            (e.imageSliderContainer = e.section.find('.slider-product-images')), (e.imageSlider = e.imageSliderContainer.find('.slider')), (e.imageThumbnailsSliderContainer = e.section.find('.slider-product-thumbnails')), (e.imageThumbnailsSlider = e.imageThumbnailsSliderContainer.find('.slider'));
            var t = {
              infinite: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow: e.imageSliderContainer.find('.slick-prev'),
              nextArrow: e.imageSliderContainer.find('.slick-next'),
            };
            e.imageThumbnailsSlider.length && (t.asNavFor = e.imageThumbnailsSlider),
              e.imageSlider.on('afterChange', function (e, t, o, i) {
                ShopifyApp.initLazyImages();
              }),
              e.imageSlider.slick(t),
              e.imageThumbnailsSlider.length &&
                e.imageThumbnailsSlider.slick({
                  infinite: !0,
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  prevArrow: e.imageThumbnailsSliderContainer.find('.slick-prev'),
                  nextArrow: e.imageThumbnailsSliderContainer.find('.slick-next'),
                  asNavFor: e.imageSlider,
                  focusOnSelect: !0,
                  vertical: !0,
                  responsive: [
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 3,
                        vertical: !1,
                      },
                    },
                    {
                      breakpoint: 1024,
                      settings: {
                        vertical: !1,
                      },
                    },
                  ],
                });
          },
        },
        {
          key: 'initProduct',
          value: function () {
            this.productObject = JSON.parse(this.section.find('[data-product-json]').html());
            var e = {
              container: this.section,
              product: this.productObject,
            };
            new Product(e);
          },
        },
        {
          key: 'initProductTabs',
          value: function () {
            var e = this;
            (e.accordion = e.section.find('.accordion')), (e.accordionItems = e.accordion.find('.accordion-content')), new Foundation.ResponsiveAccordionTabs(e.accordion);
          },
        },
        {
          key: 'initAfterPayModal',
          value: function () {
            var e = this;
            (e.modal = e.section.find('#afterpayModal')),
              (e.modalContent = this.modal.find('.modal-content')),
              e.section.find('.afterpay-modal').on('click', function () {
                e.modal.foundation(), e.modal.foundation('open');
              });
          },
        },
      ]),
      o
    );
  })(),
  */
  RelatedProductsSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return t.initSlider(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initSlider',
          value: function () {
            (this.sliderContainer = this.section.find('.products-container')),
              (this.slider = this.section.find('.products-container__slider')),
              this.slider.on('breakpoint', function (e, t, o, i) {
                ShopifyApp.refreshProducts();
              }),
              this.slider.on('beforeChange', function (event, slick, direction) {
                ShopifyApp.refreshProducts();
              }),
              this.slider.slick({
                infinite: !1,
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: this.sliderContainer.find('.slick-prev'),
                nextArrow: this.sliderContainer.find('.slick-next'),
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: !1,
                      dots: !0,
                    },
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      arrows: !1,
                      dots: !0,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3,
                    },
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4,
                    },
                  },
                ],
              });
          },
        },
      ]),
      o
    );
  })(),
  StoresSection = (function (e) {
    function o(e) {
      _classCallCheck(this, o);
      var t = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e));
      return (t.map = t.section.find('.map')), (t.googleMap = null), (t.markers = null), (t.zoom = 14), (t.directionButton = t.section.find('.button-directions')), t.initAccordion(), t.map.length && t.renderMap(), t;
    }
    return (
      _inherits(o, AbstractSection),
      _createClass(o, [
        {
          key: 'initAccordion',
          value: function () {
            var a = this;
            (a.accordion = a.section.find('.accordion')),
              (a.accordionItems = a.accordion.find('.accordion-content')),
              new Foundation.ResponsiveAccordionTabs(a.accordion),
              a.accordion.on('down.zf.accordion', function (e, t) {
                var o = t.data('location-latitude'),
                  i = t.data('location-longitude'),
                  n = t.data('location-directions-url');
                o && i && (a.clearMarkers(), a.addMarker(o, i)), a.directionButton.attr('href', n);
              });
          },
        },
        {
          key: 'renderMap',
          value: function () {
            var e = this;
            if ('undefined' == typeof google) return !1;
            var t = {
              zoom: e.zoom,
              center: new google.maps.LatLng(0, 0),
              mapTypeId: google.maps.MapTypeId.ROADMAP,
              draggable: !1,
              scrollwheel: !1,
              streetViewControl: !1,
              mapTypeControl: !1,
              panControl: !1,
              zoomControl: !1,
              scaleControl: !1,
            };
            (e.googleMap = new google.maps.Map(e.map[0], t)),
              (e.googleMap.markers = []),
              e.centerMap(),
              google.maps.event.addDomListener(window, 'resize', function () {
                google.maps.event.trigger(e.googleMap, 'resize'), e.centerMap();
              });
          },
        },
        {
          key: 'addMarker',
          value: function (e, t) {
            var o = new google.maps.LatLng(e, t),
              i = new google.maps.Marker({
                position: o,
                map: this.googleMap,
                animation: google.maps.Animation.DROP,
              });
            this.googleMap.markers.push(i), this.centerMap();
          },
        },
        {
          key: 'clearMarkers',
          value: function () {
            for (var e = 0; e < this.googleMap.markers.length; e++) this.googleMap.markers[e].setMap(null);
            this.googleMap.markers = [];
          },
        },
        {
          key: 'centerMap',
          value: function () {
            var i = new google.maps.LatLngBounds();
            $.each(this.googleMap.markers, function (e, t) {
              var o = new google.maps.LatLng(t.position.lat(), t.position.lng());
              i.extend(o);
            }),
              this.googleMap.fitBounds(i),
              this.googleMap.setZoom(this.zoom);
          },
        },
        {
          key: 'toggleBounce',
          value: function (e) {
            null != e.getAnimation() ? e.setAnimation(null) : e.setAnimation(google.maps.Animation.BOUNCE);
          },
        },
      ]),
      o
    );
  })(),
  ShopifyAppCore = (function () {
    function e() {
      _classCallCheck(this, e);
    }
    return (
      _createClass(e, [
        {
          key: 'init',
          value: function () {
            this.initAutoloadClasses(), this.initLazyImages(), this.initLocalisation();
          },
        },
        {
          key: 'initAutoloadClasses',
          value: function () {
            $('[data-autoload-class]')
              .not('[data-autoload-class-loaded]')
              .sort(function (e, t) {
                var o = $(e).data('autoload-priority'),
                  i = $(t).data('autoload-priority');
                return (o = 'number' == typeof o ? o : 999) <= (i = 'number' == typeof i ? i : 999) ? -1 : 1;
              })
              .each(function () {
                var e = $(this).data('autoload-class');
                void 0 !== window[e] && $(this).data('autoloadClass', new window[e]($(this))), $(this).attr('data-autoload-class-loaded', '');
              });
          },
        },
        {
          key: 'initLazyImages',
          value: function () {
            this.lazyLoadInstance = new LazyLoad({
              elements_selector: '.lazy',
              callback_set: function (e) {
                $(e).addClass('lazy-loaded');
              },
            });
          },
        },
        {
          key: 'lazyLoadCheckDOM',
          value: function () {
            this.lazyLoadInstance.update();
          },
        },
        {
          key: 'initLocalisation',
          value: function () {
            shopify_localisation ||
              this.queryLocalisation().then(
                function (e) {
                  SetShopifyLocalisation(e);
                },
                function () {
                  SetShopifyLocalisation('error');
                }
              );
          },
        },
        {
          key: 'queryLocalisation',
          value: function () {
            var t = $.Deferred(),
              o = new Date(),
              i = '';
            null !== window.localStorage && null !== localStorage.getItem('shopify_localisation') && new Date(localStorage.getItem('shopify_localisation_date')).setHours(0, 0, 0, 0) === o.setHours(0, 0, 0, 0) && (i = localStorage.getItem('shopify_localisation'));
            return (
              i
                ? t.resolve(i)
                : $.ajax({
                    url: 'https://ipapi.co/json',
                    jsonpCallback: 'callback',
                    dataType: 'jsonp',
                    success: function (e) {
                      localStorage.setItem('shopify_localisation_date', o), (i = 'Australia' === e.country_name ? 'domestic' : 'international'), localStorage.setItem('shopify_localisation_code', e.country_code), localStorage.setItem('shopify_localisation', i), t.resolve(i);
                    },
                    error: function (e) {
                      console.log('error'), console.log(e), localStorage.setItem('shopify_localisation_date', o), localStorage.setItem('shopify_localisation', 'error'), t.reject();
                    },
                  }),
              t
            );
          },
        },
        {
          key: 'refreshProducts',
          value: function () {
            AppQuickview.initQuickViewButtons(), this.initLazyImages(), $('body')[0].dispatchEvent(new Event('shopify-wishlist.refresh'));
          },
        },
      ]),
      e
    );
  })();
$(function () {
  (window.AppShopifyCart = new ShopifyCart()), (window.ShopifyApp = new ShopifyAppCore()), window.ShopifyApp.init(), (window.AppQuickview = new QuickView());
});

/*================ Templates ================*/
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

// Remove focus from input on iOS when clicking elsewhere
function removeFocus() {
  document.activeElement.blur();
}
document.body.addEventListener('touchstart', removeFocus);

////////////////////////////////////////////////////////////////////////////////////////////////////
// 2019-11-01 NOUS - DSH27542 - IE11 Footer Bug fix - Adding browser name to body
////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// Detect Browser Type
////////////////////////////////////////////////////////////////////////////////////
var BrowserDetect = {
  init: function () {
    this.browser = this.searchString(this.dataBrowser) || 'Other';
    this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || 'Unknown';
  },
  searchString: function (data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      this.versionSearchString = data[i].subString;

      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  },
  searchVersion: function (dataString) {
    var index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return;
    }

    var rv = dataString.indexOf('rv:');
    if (this.versionSearchString === 'Trident' && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    }
  },

  dataBrowser: [
    { string: navigator.userAgent, subString: 'Edge', identity: 'MS Edge' },
    { string: navigator.userAgent, subString: 'MSIE', identity: 'Explorer' },
    { string: navigator.userAgent, subString: 'Trident', identity: 'Explorer' },
    { string: navigator.userAgent, subString: 'Firefox', identity: 'Firefox' },
    { string: navigator.userAgent, subString: 'Opera', identity: 'Opera' },
    { string: navigator.userAgent, subString: 'OPR', identity: 'Opera' },

    { string: navigator.userAgent, subString: 'Chrome', identity: 'Chrome' },
    { string: navigator.userAgent, subString: 'Safari', identity: 'Safari' },
  ],
};

BrowserDetect.init();
// console.log("You are using <b>" + BrowserDetect.browser + "</b> with version <b>" + BrowserDetect.version + "</b>");

var bv = BrowserDetect.browser;
if (bv == 'Chrome') {
  $('body').addClass('chrome chrome' + BrowserDetect.version);
} else if (bv == 'MS Edge') {
  $('body').addClass('edge edge' + BrowserDetect.version);
} else if (bv == 'Safari') {
  $('body').addClass('safari safari' + BrowserDetect.version);
} else if (bv == 'Explorer') {
  $('body').addClass('ie ie' + BrowserDetect.version);
} else if (bv == 'Firefox') {
  $('body').addClass('Firefox Firefox' + BrowserDetect.version);
}

/*! Backstretch - v2.1.18 - 2019-09-18\n* Copyright (c) 2019 Scott Robbin;* Fork of improvements - by Daniel Cohen Gindi (danielgindi@gmail.com) Licensed MIT */ !(function (a, b, c) {
  'use strict';
  function d(a) {
    return m.hasOwnProperty(a) ? a : 'cover';
  }
  var e = /^.*(youtu\.be\/|youtube\.com\/v\/|youtube\.com\/embed\/|youtube\.com\/watch\?v=|youtube\.com\/watch\?.*\&v=)([^#\&\?]*).*/i;
  (a.fn.backstretch = function (d, e) {
    var f = arguments;
    0 === a(b).scrollTop() && b.scrollTo(0, 0);
    var g;
    return (
      this.each(function (b) {
        var h = a(this),
          i = h.data('backstretch');
        if (i) {
          if ('string' == typeof f[0] && 'function' == typeof i[f[0]]) {
            var j = i[f[0]].apply(i, Array.prototype.slice.call(f, 1));
            return j === i && (j = c), void (j !== c && ((g = g || []), (g[b] = j)));
          }
          (e = a.extend(i.options, e)), 'object' == typeof i && 'destroy' in i && i.destroy(!0);
        }
        if (!d || (d && 0 === d.length)) {
          var k = h.css('background-image');
          k && 'none' !== k ? (d = [{ url: h.css('backgroundImage').replace(/url\(|\)|"|'/g, '') }]) : a.error('No images were supplied for Backstretch, or element must have a CSS-defined background image.');
        }
        (i = new n(this, d, e || {})), h.data('backstretch', i);
      }),
      g ? (1 === g.length ? g[0] : g) : this
    );
  }),
    (a.backstretch = function (b, c) {
      return a('body').backstretch(b, c).data('backstretch');
    }),
    (a.expr[':'].backstretch = function (b) {
      return a(b).data('backstretch') !== c;
    }),
    (a.fn.backstretch.defaults = { duration: 5e3, transition: 'fade', transitionDuration: 0, animateFirst: !0, alignX: 0.5, alignY: 0.5, paused: !1, start: 0, preload: 2, preloadSize: 1, resolutionRefreshRate: 2500, resolutionChangeRatioThreshold: 0.1 });
  var f = {
      wrap: { left: 0, top: 0, overflow: 'hidden', margin: 0, padding: 0, height: '100%', width: '100%', zIndex: -999999 },
      itemWrapper: { position: 'absolute', display: 'none', margin: 0, padding: 0, border: 'none', width: '100%', height: '100%', zIndex: -999999 },
      item: { position: 'absolute', margin: 0, padding: 0, border: 'none', width: '100%', height: '100%', maxWidth: 'none' },
    },
    g = (function () {
      var c = function (a) {
          for (var b = 1; b < a.length; b++) {
            for (var c = a[b], d = b; a[d - 1] && parseInt(a[d - 1].width, 10) > parseInt(c.width, 10); ) (a[d] = a[d - 1]), --d;
            a[d] = c;
          }
          return a;
        },
        d = function (a, c, d) {
          for (
            var e, f, g = b.devicePixelRatio || 1, h = q(), i = (r(), c > a ? 'portrait' : a > c ? 'landscape' : 'square'), j = 0, k = 0;
            k < d.length &&
            ((f = d[k]),
            'string' == typeof f && (f = d[k] = { url: f }),
            (f.pixelRatio && 'auto' !== f.pixelRatio && parseFloat(f.pixelRatio) !== g) ||
              (f.deviceOrientation && f.deviceOrientation !== h) ||
              (f.windowOrientation && f.windowOrientation !== h) ||
              (f.orientation && f.orientation !== i) ||
              ((j = k), (e = a), 'auto' === f.pixelRatio && (a *= g), !(f.width >= e)));
            k++
          );
          return d[Math.min(k, j)];
        },
        e = function (a, b) {
          if ('string' == typeof a) a = a.replace(/{{(width|height)}}/g, b);
          else if (a instanceof Array) for (var c = 0; c < a.length; c++) a[c].src ? (a[c].src = e(a[c].src, b)) : (a[c] = e(a[c], b));
          return a;
        };
      return function (b, f) {
        for (
          var g = b.width(),
            h = b.height(),
            i = [],
            j = function (a, b) {
              return 'width' === b ? g : 'height' === b ? h : a;
            },
            k = 0;
          k < f.length;
          k++
        )
          if (a.isArray(f[k])) {
            f[k] = c(f[k]);
            var l = d(g, h, f[k]);
            i.push(l);
          } else {
            'string' == typeof f[k] && (f[k] = { url: f[k] });
            var m = a.extend({}, f[k]);
            (m.url = e(m.url, j)), i.push(m);
          }
        return i;
      };
    })(),
    h = function (a) {
      return e.test(a.url) || a.isVideo;
    },
    i = (function (b, c, d, e, f) {
      var g = [],
        i = function (a) {
          for (var b = 0; b < g.length; b++) if (g[b].src === a.src) return g[b];
          return g.push(a), a;
        },
        j = function (a, b, c) {
          'function' == typeof b && b.call(a, c);
        };
      return function b(c, d, e, f, g) {
        if ('undefined' != typeof c) {
          a.isArray(c) || (c = [c]),
            arguments.length < 5 && 'function' == typeof arguments[arguments.length - 1] && (g = arguments[arguments.length - 1]),
            (d = 'function' != typeof d && d ? d : 0),
            (e = 'function' == typeof e || !e || e < 0 ? c.length : Math.min(e, c.length)),
            (f = 'function' != typeof f && f ? f : 1),
            d >= c.length && ((d = 0), (e = 0)),
            f < 0 && (f = e),
            (f = Math.min(f, e));
          var k = c.slice(d + f, e - f);
          if (((c = c.slice(d, f)), (e = c.length), !e)) return void j(c, g, !0);
          for (
            var l,
              m = 0,
              n = function () {
                m++, m === e && (j(c, g, !k), b(k, 0, 0, f, g));
              },
              o = 0;
            o < c.length;
            o++
          )
            h(c[o]) || ((l = new Image()), (l.src = c[o].url), (l = i(l)), l.complete ? n() : a(l).on('load error', n));
        }
      };
    })(),
    j = function (b) {
      for (var c = [], d = 0; d < b.length; d++) 'string' == typeof b[d] ? c.push({ url: b[d] }) : a.isArray(b[d]) ? c.push(j(b[d])) : c.push(k(b[d]));
      return c;
    },
    k = function (a, e) {
      return (
        (a.centeredX || a.centeredY) && (b.console && b.console.log && b.console.log('jquery.backstretch: `centeredX`/`centeredY` is deprecated, please use `alignX`/`alignY`'), a.centeredX && (a.alignX = 0.5), a.centeredY && (a.alignY = 0.5)),
        a.speed !== c && (b.console && b.console.log && b.console.log('jquery.backstretch: `speed` is deprecated, please use `transitionDuration`'), (a.transitionDuration = a.speed), (a.transition = 'fade')),
        a.resolutionChangeRatioTreshold !== c && (b.console.log('jquery.backstretch: `treshold` is a typo!'), (a.resolutionChangeRatioThreshold = a.resolutionChangeRatioTreshold)),
        a.fadeFirst !== c && (a.animateFirst = a.fadeFirst),
        a.fade !== c && ((a.transitionDuration = a.fade), (a.transition = 'fade')),
        a.scale && (a.scale = d(a.scale)),
        l(a)
      );
    },
    l = function (a, b) {
      return (
        'left' === a.alignX ? (a.alignX = 0) : 'center' === a.alignX ? (a.alignX = 0.5) : 'right' === a.alignX ? (a.alignX = 1) : (a.alignX !== c || b) && ((a.alignX = parseFloat(a.alignX)), isNaN(a.alignX) && (a.alignX = 0.5)),
        'top' === a.alignY ? (a.alignY = 0) : 'center' === a.alignY ? (a.alignY = 0.5) : 'bottom' === a.alignY ? (a.alignY = 1) : (a.alignX !== c || b) && ((a.alignY = parseFloat(a.alignY)), isNaN(a.alignY) && (a.alignY = 0.5)),
        a
      );
    },
    m = { cover: 'cover', fit: 'fit', 'fit-smaller': 'fit-smaller', fill: 'fill' },
    n = function (c, d, e) {
      (this.options = a.extend({}, a.fn.backstretch.defaults, e || {})),
        (this.firstShow = !0),
        k(this.options, !0),
        (this.images = j(a.isArray(d) ? d : [d])),
        this.options.paused && (this.paused = !0),
        this.options.start >= this.images.length && (this.options.start = this.images.length - 1),
        this.options.start < 0 && (this.options.start = 0),
        (this.isBody = c === document.body);
      var h = a(b);
      (this.$container = a(c)),
        (this.$root = this.isBody ? (s ? h : a(document)) : this.$container),
        (this.originalImages = this.images),
        (this.images = g(this.options.alwaysTestWindowResolution ? h : this.$root, this.originalImages)),
        i(this.images, this.options.start || 0, this.options.preload || 1);
      var l = this.$container.children('.backstretch').first();
      if (
        ((this.$wrap = l.length
          ? l
          : a('<div class="backstretch"></div>')
              .css(this.options.bypassCss ? {} : f.wrap)
              .appendTo(this.$container)),
        !this.options.bypassCss)
      ) {
        if (!this.isBody) {
          var m = this.$container.css('position'),
            n = this.$container.css('zIndex');
          this.$container.css({ position: 'static' === m ? 'relative' : m, zIndex: 'auto' === n ? 0 : n }), this.$wrap.css({ zIndex: -999998 });
        }
        this.$wrap.css({ position: this.isBody && s ? 'fixed' : 'absolute' });
      }
      (this.index = this.options.start),
        this.show(this.index),
        h.on('resize.backstretch', a.proxy(this.resize, this)).on(
          'orientationchange.backstretch',
          a.proxy(function () {
            this.isBody && 0 === b.pageYOffset && (b.scrollTo(0, 1), this.resize());
          }, this)
        );
    },
    o = function (b) {
      var d = b.transition || 'fade';
      'string' == typeof d && d.indexOf('|') > -1 && (d = d.split('|')), d instanceof Array && (d = d[Math.round(Math.random() * (d.length - 1))]);
      var e = b.new,
        f = b.old ? b.old : a([]);
      switch (d.toString().toLowerCase()) {
        default:
        case 'fade':
          e.fadeIn({ duration: b.duration, complete: b.complete, easing: b.easing || c });
          break;
        case 'fadeinout':
        case 'fade_in_out':
          var g = function () {
            e.fadeIn({ duration: b.duration / 2, complete: b.complete, easing: b.easing || c });
          };
          f.length ? f.fadeOut({ duration: b.duration / 2, complete: g, easing: b.easing || c }) : g();
          break;
        case 'pushleft':
        case 'push_left':
        case 'pushright':
        case 'push_right':
        case 'pushup':
        case 'push_up':
        case 'pushdown':
        case 'push_down':
        case 'coverleft':
        case 'cover_left':
        case 'coverright':
        case 'cover_right':
        case 'coverup':
        case 'cover_up':
        case 'coverdown':
        case 'cover_down':
          var h = d.match(/^(cover|push)_?(.*)$/),
            i = 'left' === h[2] ? 'right' : 'right' === h[2] ? 'left' : 'down' === h[2] ? 'top' : 'up' === h[2] ? 'bottom' : 'right',
            j = { display: '' },
            k = {};
          if (
            ((j[i] = '-100%'),
            (k[i] = 0),
            e.css(j).animate(k, {
              duration: b.duration,
              complete: function () {
                e.css(i, ''), b.complete.apply(this, arguments);
              },
              easing: b.easing || c,
            }),
            'push' === h[1] && f.length)
          ) {
            var l = {};
            (l[i] = '100%'),
              f.animate(l, {
                duration: b.duration,
                complete: function () {
                  f.css('display', 'none');
                },
                easing: b.easing || c,
              });
          }
      }
    };
  n.prototype = {
    resize: function () {
      try {
        var e = this.options.alwaysTestWindowResolution ? a(b) : this.$root,
          f = e.width(),
          h = e.height(),
          j = f / (this._lastResizeContainerWidth || 0),
          k = h / (this._lastResizeContainerHeight || 0),
          l = this.options.resolutionChangeRatioThreshold || 0;
        if (
          (f !== this._lastResizeContainerWidth || h !== this._lastResizeContainerHeight) &&
          (Math.abs(j - 1) >= l || isNaN(j) || Math.abs(k - 1) >= l || isNaN(k)) &&
          ((this._lastResizeContainerWidth = f),
          (this._lastResizeContainerHeight = h),
          (this.images = g(e, this.originalImages)),
          this.options.preload && i(this.images, (this.index + 1) % this.images.length, this.options.preload),
          1 === this.images.length && this._currentImage.url !== this.images[0].url)
        ) {
          var m = this;
          clearTimeout(m._selectAnotherResolutionTimeout),
            (m._selectAnotherResolutionTimeout = setTimeout(function () {
              m.show(0);
            }, this.options.resolutionRefreshRate));
        }
        var n,
          o,
          p = { left: 0, top: 0, right: 'auto', bottom: 'auto' },
          q = this.isBody ? this.$root.width() : this.$root.innerWidth(),
          r = this.isBody ? (b.innerHeight ? b.innerHeight : this.$root.height()) : this.$root.innerHeight(),
          s = this.$itemWrapper.data('width'),
          t = this.$itemWrapper.data('height'),
          u = s / t || 1,
          v = this._currentImage.alignX === c ? this.options.alignX : this._currentImage.alignX,
          w = this._currentImage.alignY === c ? this.options.alignY : this._currentImage.alignY,
          x = d(this._currentImage.scale || this.options.scale);
        if ('fit' === x || 'fit-smaller' === x) {
          if (((n = s), (o = t), n > q || o > r || 'fit-smaller' === x)) {
            var y = q / r;
            y > u ? ((n = Math.floor(r * u)), (o = r)) : y < u ? ((n = q), (o = Math.floor(q / u))) : ((n = q), (o = r));
          }
        } else 'fill' === x ? ((n = q), (o = r)) : ((n = Math.max(r * u, q)), (o = Math.max(n / u, r)));
        (p.top = -(o - r) * w),
          (p.left = -(n - q) * v),
          (p.width = n),
          (p.height = o),
          this.options.bypassCss ||
            this.$wrap
              .css({ width: q, height: r })
              .find('>.backstretch-item')
              .not('.deleteable')
              .each(function () {
                var b = a(this);
                b.find('img,video,iframe').css(p);
              });
        var z = a.Event('backstretch.resize', { relatedTarget: this.$container[0] });
        this.$container.trigger(z, this);
      } catch (a) {}
      return this;
    },
    show: function (b, d) {
      if (!(Math.abs(b) > this.images.length - 1)) {
        var e = this,
          g = e.$wrap.find('>.backstretch-item').addClass('deleteable'),
          i = e.videoWrapper,
          j = { relatedTarget: e.$container[0] };
        e.$container.trigger(a.Event('backstretch.before', j), [e, b]), (this.index = b);
        var k = e.images[b];
        clearTimeout(e._cycleTimeout), delete e.videoWrapper;
        var l = h(k);
        return (
          l ? ((e.videoWrapper = new p(k)), (e.$item = e.videoWrapper.$video.css('pointer-events', 'none'))) : (e.$item = a('<img />')),
          (e.$itemWrapper = a('<div class="backstretch-item">').append(e.$item)),
          this.options.bypassCss ? e.$itemWrapper.css({ display: 'none' }) : (e.$itemWrapper.css(f.itemWrapper), e.$item.css(f.item)),
          e.$item.bind(l ? 'canplay' : 'load', function (f) {
            var h = a(this),
              k = h.parent(),
              m = k.data('options');
            d && (m = a.extend({}, m, d));
            var n = this.naturalWidth || this.videoWidth || this.width,
              p = this.naturalHeight || this.videoHeight || this.height;
            k.data('width', n).data('height', p);
            var q = function (a) {
                return m[a] !== c ? m[a] : e.options[a];
              },
              r = q('transition'),
              s = q('transitionEasing'),
              t = q('transitionDuration'),
              u = function () {
                i && (i.stop(), i.destroy()),
                  g.remove(),
                  !e.paused && e.images.length > 1 && e.cycle(),
                  e.options.bypassCss || e.isBody || e.$container.css('background-image', 'none'),
                  a(['after', 'show']).each(function () {
                    e.$container.trigger(a.Event('backstretch.' + this, j), [e, b]);
                  }),
                  l && e.videoWrapper.play();
              };
            (e.firstShow && !e.options.animateFirst) || !t || !r ? (k.show(), u()) : o({ new: k, old: g, transition: r, duration: t, easing: s, complete: u }), (e.firstShow = !1), e.resize();
          }),
          e.$itemWrapper.appendTo(e.$wrap),
          e.$item.attr('alt', k.alt || ''),
          e.$itemWrapper.data('options', k),
          l || e.$item.attr('src', k.url),
          (e._currentImage = k),
          e
        );
      }
    },
    current: function () {
      return this.index;
    },
    next: function () {
      var a = Array.prototype.slice.call(arguments, 0);
      return a.unshift(this.index < this.images.length - 1 ? this.index + 1 : 0), this.show.apply(this, a);
    },
    prev: function () {
      var a = Array.prototype.slice.call(arguments, 0);
      return a.unshift(0 === this.index ? this.images.length - 1 : this.index - 1), this.show.apply(this, a);
    },
    pause: function () {
      return (this.paused = !0), this.videoWrapper && this.videoWrapper.pause(), this;
    },
    resume: function () {
      return (this.paused = !1), this.videoWrapper && this.videoWrapper.play(), this.cycle(), this;
    },
    cycle: function () {
      if (this.images.length > 1) {
        clearTimeout(this._cycleTimeout);
        var b = (this._currentImage && this._currentImage.duration) || this.options.duration,
          c = h(this._currentImage),
          d = function () {
            this.$item.off('.cycle'), this.paused || this.next();
          };
        if (c) {
          if (!this._currentImage.loop) {
            var e = 0;
            this.$item
              .on('playing.cycle', function () {
                var b = a(this).data('player');
                clearTimeout(e),
                  (e = setTimeout(function () {
                    b.pause(), b.$video.trigger('ended');
                  }, 1e3 * (b.getDuration() - b.getCurrentTime())));
              })
              .on('ended.cycle', function () {
                clearTimeout(e);
              });
          }
          this.$item.on('error.cycle initerror.cycle', a.proxy(d, this));
        }
        c && !this._currentImage.duration ? this.$item.on('ended.cycle', a.proxy(d, this)) : (this._cycleTimeout = setTimeout(a.proxy(d, this), b));
      }
      return this;
    },
    destroy: function (c) {
      a(b).off('resize.backstretch orientationchange.backstretch'), this.videoWrapper && this.videoWrapper.destroy(), clearTimeout(this._cycleTimeout), c || this.$wrap.remove(), this.$container.removeData('backstretch');
    },
  };
  var p = function () {
    this.init.apply(this, arguments);
  };
  (p.prototype.init = function (d) {
    var f,
      g = this,
      h = function () {
        (g.$video = f), (g.video = f[0]);
      },
      i = 'video';
    if ((d.url instanceof Array || !e.test(d.url) || (i = 'youtube'), (g.type = i), 'youtube' === i)) {
      p.loadYoutubeAPI(), (g.ytId = d.url.match(e)[2]);
      var j = 'https://www.youtube.com/embed/' + g.ytId + '?rel=0&autoplay=0&showinfo=0&controls=0&modestbranding=1&cc_load_policy=0&disablekb=1&iv_load_policy=3&loop=0&enablejsapi=1&origin=' + encodeURIComponent(b.location.origin);
      (g.__ytStartMuted = !!d.mute || d.mute === c),
        (f = a('<iframe />').attr({ src_to_load: j }).css({ border: 0, margin: 0, padding: 0 }).data('player', g)),
        d.loop &&
          f.on('ended.loop', function () {
            g.__manuallyStopped || g.play();
          }),
        (g.ytReady = !1),
        h(),
        b.YT && b.YT.loaded
          ? (g._initYoutube(), f.trigger('initsuccess'))
          : a(b).one('youtube_api_load', function () {
              g._initYoutube(), f.trigger('initsuccess');
            });
    } else {
      f = a('<video>')
        .prop('autoplay', !1)
        .prop('controls', !1)
        .prop('loop', !!d.loop)
        .prop('muted', !!d.mute || d.mute === c)
        .prop('preload', 'auto')
        .prop('poster', d.poster || '');
      for (var k = d.url instanceof Array ? d.url : [d.url], l = 0; l < k.length; l++) {
        var m = k[l];
        'string' == typeof m && (m = { src: m }),
          a('<source>')
            .attr('src', m.src)
            .attr('type', m.type || null)
            .appendTo(f);
      }
      f[0].canPlayType && k.length ? f.trigger('initsuccess') : f.trigger('initerror'), h();
    }
  }),
    (p.prototype._initYoutube = function () {
      var c = this,
        d = b.YT;
      c.$video.attr('src', c.$video.attr('src_to_load')).removeAttr('src_to_load');
      var e = !!c.$video[0].parentNode;
      if (!e) {
        var f = a('<div>').css('display', 'none !important').appendTo(document.body);
        c.$video.appendTo(f);
      }
      var g = new d.Player(c.video, {
        events: {
          onReady: function () {
            c.__ytStartMuted && g.mute(), e || (c.$video[0].parentNode === f[0] && c.$video.detach(), f.remove()), (c.ytReady = !0), c._updateYoutubeSize(), c.$video.trigger('canplay');
          },
          onStateChange: function (a) {
            switch (a.data) {
              case d.PlayerState.PLAYING:
                c.$video.trigger('playing');
                break;
              case d.PlayerState.ENDED:
                c.$video.trigger('ended');
                break;
              case d.PlayerState.PAUSED:
                c.$video.trigger('pause');
                break;
              case d.PlayerState.BUFFERING:
                c.$video.trigger('waiting');
                break;
              case d.PlayerState.CUED:
                c.$video.trigger('canplay');
            }
          },
          onPlaybackQualityChange: function () {
            c._updateYoutubeSize(), c.$video.trigger('resize');
          },
          onError: function (a) {
            (c.hasError = !0), c.$video.trigger({ type: 'error', error: a });
          },
        },
      });
      return (c.ytPlayer = g), c;
    }),
    (p.prototype._updateYoutubeSize = function () {
      var a = this;
      switch (a.ytPlayer.getPlaybackQuality() || 'medium') {
        case 'small':
          (a.video.videoWidth = 426), (a.video.videoHeight = 240);
          break;
        case 'medium':
          (a.video.videoWidth = 640), (a.video.videoHeight = 360);
          break;
        default:
        case 'large':
          (a.video.videoWidth = 854), (a.video.videoHeight = 480);
          break;
        case 'hd720':
          (a.video.videoWidth = 1280), (a.video.videoHeight = 720);
          break;
        case 'hd1080':
          (a.video.videoWidth = 1920), (a.video.videoHeight = 1080);
          break;
        case 'highres':
          (a.video.videoWidth = 2560), (a.video.videoHeight = 1440);
      }
      return a;
    }),
    (p.prototype.play = function () {
      var a = this;
      return (a.__manuallyStopped = !1), 'youtube' === a.type ? a.ytReady && (a.$video.trigger('play'), a.ytPlayer.playVideo()) : a.video.play(), a;
    }),
    (p.prototype.pause = function () {
      var a = this;
      return (a.__manuallyStopped = !1), 'youtube' === a.type ? a.ytReady && a.ytPlayer.pauseVideo() : a.video.pause(), a;
    }),
    (p.prototype.stop = function () {
      var a = this;
      return (a.__manuallyStopped = !0), 'youtube' === a.type ? a.ytReady && (a.ytPlayer.pauseVideo(), a.ytPlayer.seekTo(0)) : (a.video.pause(), (a.video.currentTime = 0)), a;
    }),
    (p.prototype.destroy = function () {
      var a = this;
      return a.ytPlayer && a.ytPlayer.destroy(), a.$video.remove(), a;
    }),
    (p.prototype.getCurrentTime = function (a) {
      var b = this;
      return 'youtube' !== b.type ? b.video.currentTime : b.ytReady ? b.ytPlayer.getCurrentTime() : 0;
    }),
    (p.prototype.setCurrentTime = function (a) {
      var b = this;
      return 'youtube' === b.type ? b.ytReady && b.ytPlayer.seekTo(a, !0) : (b.video.currentTime = a), b;
    }),
    (p.prototype.getDuration = function () {
      var a = this;
      return 'youtube' !== a.type ? a.video.duration : a.ytReady ? a.ytPlayer.getDuration() : 0;
    }),
    (p.loadYoutubeAPI = function () {
      (b.YT && b.__yt_load_event_interval__) ||
        (b.YT || a('script[src*=www\\.youtube\\.com\\/iframe_api]').length || a('<script type="text/javascript" src="https://www.youtube.com/iframe_api">').appendTo('body'),
        (b.__yt_load_event_interval__ = setInterval(function () {
          b.YT && b.YT.loaded && (a(b).trigger('youtube_api_load'), clearTimeout(b.__yt_load_event_interval__), delete b.__yt_load_event_interval__);
        }, 50)));
    });
  var q = function () {
      if ('matchMedia' in b) {
        if (b.matchMedia('(orientation: portrait)').matches) return 'portrait';
        if (b.matchMedia('(orientation: landscape)').matches) return 'landscape';
      }
      return screen.height > screen.width ? 'portrait' : 'landscape';
    },
    r = function () {
      return b.innerHeight > b.innerWidth ? 'portrait' : b.innerWidth > b.innerHeight ? 'landscape' : 'square';
    },
    s = (function () {
      var a = navigator.userAgent,
        c = navigator.platform,
        d = a.match(/AppleWebKit\/([0-9]+)/),
        e = !!d && d[1],
        f = a.match(/Fennec\/([0-9]+)/),
        g = !!f && f[1],
        h = a.match(/Opera Mobi\/([0-9]+)/),
        i = !!h && h[1],
        j = a.match(/MSIE ([0-9]+)/),
        k = !!j && j[1];
      return !(
        ((c.indexOf('iPhone') > -1 || c.indexOf('iPad') > -1 || c.indexOf('iPod') > -1) && e && e < 534) ||
        (b.operamini && '[object OperaMini]' === {}.toString.call(b.operamini)) ||
        (h && i < 7458) ||
        (a.indexOf('Android') > -1 && e && e < 533) ||
        (g && g < 6) ||
        ('palmGetResource' in b && e && e < 534) ||
        (a.indexOf('MeeGo') > -1 && a.indexOf('NokiaBrowser/8.5.0') > -1) ||
        (k && k <= 6)
      );
    })();
})(jQuery, window);

////////////////////////////////////////////////////////////////////////////////////
// 2020-07-17 NOUS DSH29020 Homepage Redesign
// Takeover Banner Function
////////////////////////////////////////////////////////////////////////////////////
function takeoverImg() {
  ////////////////////////////////////////////////////////////////////////////////////
  // IF Take Over Exists
  ////////////////////////////////////////////////////////////////////////////////////
  if ($('#js-take-over').length) {
    ////////////////////////////////////////////////////////////////////////////////////
    // Variables
    ////////////////////////////////////////////////////////////////////////////////////
    var bgImg = $('#js-take-over').attr('data-bg-img');
    var windowHeight = $(window).height();
    var elementHeight = 0;
    var elementClasses = ['site-header', 'section-offers'];

    ////////////////////////////////////////////////////////////////////////////////////
    // Foreach Element
    ////////////////////////////////////////////////////////////////////////////////////
    $.each(elementClasses, function (index, className) {
      if ($('.' + className).length) {
        elementHeight += $('.' + className).outerHeight();
      }
    });

    ////////////////////////////////////////////////////////////////////////////////////
    // IF !EMPTY ElementHeight
    ////////////////////////////////////////////////////////////////////////////////////
    if (elementHeight != 0) {
      $('#js-take-over').css('height', windowHeight - elementHeight - 20 + 'px');
      $('#js-take-over').backstretch(bgImg);
    }
  }
}

////////////////////////////////////////////////////////////////////////////////////
// Document Ready Function
////////////////////////////////////////////////////////////////////////////////////
$(document).ready(function () {
  ////////////////////////////////////////////////////////////////////////////////////
  // 2020-08-18 NOUS DSH29501 - Account Validation
  ////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////
  // Input Limits
  ////////////////////////////////////////////////////////////////////////////////////
  $('input[name*="address[first_name]"], input[name*="address[last_name]"], input[name*="address[address1]"]').attr('maxlength', '30');
  $('input[name*="address[address2]"]').attr('maxlength', '25');
  $('input[name*="address[zip]"]').attr('maxlength', '10');

  ////////////////////////////////////////////////////////////////////////////////////
  // Input Validation
  ////////////////////////////////////////////////////////////////////////////////////
  $('input[name*="address[first_name]"], input[name*="address[last_name]"]').on('input', function () {
    var c = this.selectionStart,
      r = /[^a-z ]/gi,
      v = $(this).val();
    if (r.test(v)) {
      $(this).val(v.replace(r, ''));
      c--;
    }
    this.setSelectionRange(c, c);
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Address Validation
  ////////////////////////////////////////////////////////////////////////////////////
  $('input[name*="address[address1]"], input[name*="address[address2]"]').on('input', function () {
    var c = this.selectionStart,
      r = /[^a-z0-9-/ ]/gi,
      v = $(this).val();
    if (r.test(v)) {
      $(this).val(v.replace(r, ''));
      c--;
    }
    this.setSelectionRange(c, c);
  });
  ////////////////////////////////////////////////////////////////////////////////////
  // END - 2020-08-18 NOUS DSH29501 - Account Validation
  ////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////
  // Init Takeover IMG
  ////////////////////////////////////////////////////////////////////////////////////
  takeoverImg();
});

////////////////////////////////////////////////////////////////////////////////////
// Window Resize
////////////////////////////////////////////////////////////////////////////////////
$(window).resize(function () {
  ////////////////////////////////////////////////////////////////////////////////////
  // Init Takeover IMG
  ////////////////////////////////////////////////////////////////////////////////////
  takeoverImg();
});

$(document).ready(function () {
  $('body').on('click', '#RegisterForm .btn', function () {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    } else {
      alert('You must agree with the terms and conditions of sales to check out.');
      return false;
    }
  });
});
